import { z } from 'zod'
import { TIPOLOGIE_IMPIANTO, TIPOLOGIE_DICHIARANTE } from '@praticheenergia/domain'

const Indirizzo = z.object({
  comune: z.string().min(1, 'Comune obbligatorio'),
  provincia: z.string().length(2, 'Sigla provincia di due lettere'),
  indirizzo: z.string().min(1, 'Indirizzo obbligatorio'),
})
export type Indirizzo = z.infer<typeof Indirizzo>

const Azienda = z.discriminatedUnion('modo', [
  z.object({ modo: z.literal('esistente'), aziendaId: z.number().int().positive() }),
  z.object({
    modo: z.literal('nuova'),
    ragioneSociale: z.string().min(1, 'Ragione sociale obbligatoria'),
    codiceFiscale: z.string().min(11, 'Codice fiscale non valido'),
  }),
])

// ponytail: il piano elencava anche 'cessione_parziale_esente', ma i suoi stessi
// test la vogliono valida senza potenza. Le cessioni tassabili la dichiarano,
// la parziale esente (esente da accisa) no.
const RICHIEDONO_POTENZA = ['cessione_parziale_commerciale', 'cessione_totale'] as const

export const SchemaImpianto = z
  .object({
    azienda: Azienda,
    codiceImpianto: z.string().optional(),
    codiceDitta: z.string().min(1, 'Codice ditta obbligatorio'),
    tipologia: z.enum(TIPOLOGIE_IMPIANTO).refine((t) => t !== 'non_configurato', {
      message: 'Tipologia non selezionabile',
    }),
    tipologiaDichiarante: z.enum(TIPOLOGIE_DICHIARANTE),
    operatoreId: z.string().uuid().optional(),
    ubicazione: Indirizzo,
    ufficioContabilita: Indirizzo,
    soggettoObbligato: Indirizzo.optional(),
    annoPrimaDichiarazione: z.number().int().optional(),
    potenzaNominale: z.number().positive().optional(),
    numeroContatori: z.number().int().positive().optional(),
    codiceDestinatarioOfficina: z.string().optional(),
    note: z.string().default(''),
  })
  .refine(
    (d) => !RICHIEDONO_POTENZA.includes(d.tipologia as (typeof RICHIEDONO_POTENZA)[number]) || d.potenzaNominale !== undefined,
    { message: 'La potenza nominale e obbligatoria per questa tipologia', path: ['potenzaNominale'] },
  )
  // CodAtt 4 (tracciato semestrale): l'autorizzazione alla vendita e' il
  // dichiarante del solo impianto di vendita, in entrambi i sensi.
  .refine(
    (d) => (d.tipologia === 'impianto_vendita') === (d.tipologiaDichiarante === 'autorizzazione_vendita_consumatore_finale'),
    {
      message: 'L impianto di vendita dichiara con autorizzazione alla vendita, e solo lui',
      path: ['tipologiaDichiarante'],
    },
  )
  .refine((d) => d.soggettoObbligato === undefined || (d.annoPrimaDichiarazione ?? 9999) < 2021, {
    message: 'Il soggetto obbligato si usa solo per dichiarazioni antecedenti al 2021',
    path: ['soggettoObbligato'],
  })

export type DatiImpianto = z.infer<typeof SchemaImpianto>
